function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.4547 11.7717C11.2151 12.0113 10.8378 12.0113 10.5981 11.7717C10.3665 11.5401 10.3665 11.1547 10.5981 10.9237L14.9418 6.58001L0.608298 6.58001C0.27417 6.58001 -3.95615e-05 6.31444 -3.95323e-05 5.98031C-3.95031e-05 5.64618 0.27417 5.37197 0.608298 5.37197L14.9418 5.37197L10.5981 1.03642C10.3665 0.796753 10.3665 0.410808 10.5981 0.179779C10.8378 -0.0598856 11.2151 -0.0598855 11.4547 0.17978L16.8267 5.55172C17.0583 5.78329 17.0583 6.1687 16.8267 6.39972L11.4547 11.7717Z",
  fill: "#1E201D"
});

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowRight.a428349e.svg";
export { ForwardRef as ReactComponent };